import axios from 'axios'
import store from '../../store'

import { Message } from 'element-ui'
import * as Strings from '../../assets/strings'

export default function setup () {
  axios.interceptors.request.use(function (config) {
    // console.log('TCL: setup -> store.auth.state', store.state)
    const token = store.state.auth['access_token']
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })

  axios.interceptors.response.use((response) => { // intercept the global error
    return response
  }, function (error) {
    console.log('response ERROR', error)
    let originalRequest = error.config
    let urlLastIndex = error.config.url.substr(error.config.url.lastIndexOf('/') + 1)
    if (error.response) {
      if (error.response.status === 404) {
        Message.error(Strings.messages.errors.notFound)
      } else if (error.response.status === 401) {
        originalRequest._retry = true
        if (urlLastIndex !== 'login' && urlLastIndex !== 'logout') store.dispatch('auth/logout') // do not dispatch logout if error from calling login and logout
        if (error.response.config.data && !error.response.config.data.hasOwnProperty('password')) {
          Message.error(`terjadi kesalahan. Silahkan masuk kembali`)
        }
      } else if (error.response.data) {
        console.log('TCL: setup -> error.response.data', error.response.data)
        Message.error(error.response.data.message)
      }
    } else if (error.request) {
      Message.error(Strings.messages.errors.noInternet)
    } else {
      Message.error(Strings.messages.errors.common)
    }
    // Do something with response error
    return Promise.reject(error)
  })
}
